import { formatDefaultDate } from 'plugin/helper'
import React, { Component } from 'react'
import { Card } from 'react-bootstrap'

class ProfilePeserta extends Component {
  constructor(props) {
    super(props)
    this.state = {
      kartu: {},
      kepegawaian: {},
      profile: {},
    }
  }

  retrieveData = (cardValue, profilePeserta, profileKepegawaian) => {
    let dataKartu = {
      fullName: cardValue.fullName,
      cardNo: cardValue.cardNo,
      efektifDate: cardValue.efektifDate,
      productName: cardValue.productName,
    }

    let dataProfile = {
      statusName: profilePeserta.statusName,
      nama: profilePeserta.nama,
      noKtp: profilePeserta.noKtp,
      tanggalLahir: profilePeserta.tanggalLahir,
      noHp: profilePeserta.noHp,
      jenisKelamin: profilePeserta.jenisKelamin,
      email: profilePeserta.email,
      statusPerkawinan: profilePeserta.statusPerkawinan,
      alamatIdentitas: profilePeserta.alamatIdentitas,
      npwp: profilePeserta.npwp,
      alamatKorespondensi: profilePeserta.alamatKorespondensi,
      statusPajak: profilePeserta.statusPajak,
      jenisPembayaranIuran: profilePeserta.jenisPembayaranIuran,
      rekeningBank: profilePeserta.rekeningBank,
      rekeningAutoDebet: profilePeserta.rekeningAutoDebet,
    }

    let dataKepegawaian = {
      bulan: profileKepegawaian.bulan,
      tahun: profileKepegawaian.tahun,
      hari: profileKepegawaian.hari,
      pesertaSejak: profileKepegawaian.pesertaSejak,
      pemberiKerja: profileKepegawaian.pemberiKerja,
    }

    this.setState({
      kartu: dataKartu,
      profile: dataProfile,
      kepegawaian: dataKepegawaian,
    })
  }

  render() {
    let { kartu, profile, kepegawaian } = this.state
    return (
      <div>
        <Card style={{ height: '1035px' }}>
          <Card.Body
            style={{
              paddingTop: '12px',
              paddingRight: '16px',
              paddingBottom: '12px',
              paddingLeft: '16px',
              overflowY: 'auto',
              maxHeight: '1030px',
            }}
          >
            <section className="d-flex flex-row justify-content-center mt-2">
              <div ref={this.divRef} className="cardStyle">
                <div className={'cardNipStyle'}>
                  {kartu.cardNo ? kartu.cardNo : '-'}
                </div>
                <div className={'cardNamaProdukStyle'}>
                  {kartu.productName ? kartu.productName : '-'}
                </div>
                <div className={'cardNamaPesertaStyle'}>
                  {kartu.fullName ? kartu.fullName : '-'}
                </div>
                <div className={'cardKepesertaanStyle'}>
                  <div className={'fontA'}>Kepesertaan Aktif</div>
                  <div className={'fontB'}>
                    {kartu.efektifDate
                      ? formatDefaultDate(new Date(kartu.efektifDate))
                      : '-'}
                  </div>
                </div>
              </div>
            </section>

            <section className="mt-4" style={{ fontSize: '14px' }}>
              <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                Kepegawaian
              </span>
              <div className="row mb-2 mt-2">
                <div className="col-md-6">
                  <span>Pemberi Kerja</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {kepegawaian.pemberiKerja ? kepegawaian.pemberiKerja : '-'}
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <span>Peserta Sejak</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {kepegawaian.pesertaSejak
                      ? formatDefaultDate(new Date(kepegawaian.pesertaSejak))
                      : '-'}
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <span>Periode Bekerja</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {kepegawaian.tahun ? kepegawaian.tahun : '0'} Tahun &nbsp;
                    {kepegawaian.bulan ? kepegawaian.bulan : '0'} Bulan &nbsp;
                    {kepegawaian.hari ? kepegawaian.hari : '0'} Hari
                  </span>
                </div>
              </div>
            </section>

            <section className="mt-4" style={{ fontSize: '14px' }}>
              <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                Profile
              </span>
              <div className="row mb-2 mt-2">
                <div className="col-md-6">
                  <span>Status</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {profile.statusName
                      ? profile.statusName === 'Aktif'
                        ? 'Peserta Aktif'
                        : 'Peserta Pasif'
                      : '-'}
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <span>Nama</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {profile.nama ? profile.nama : '-'}
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <span>No. KTP</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {profile.noKtp ? profile.noKtp : '-'}
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <span>Tanggal Lahir</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {profile.tanggalLahir
                      ? formatDefaultDate(new Date(profile.tanggalLahir))
                      : '-'}
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <span>No. HP</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {profile.noHp ? profile.noHp : '-'}
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <span>Jenis Kelamin</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {profile.jenisKelamin
                      ? profile.jenisKelamin === '0'
                        ? 'Laki-Laki'
                        : 'Perempuan'
                      : '-'}
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <span>E-Mail</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {profile.email ? profile.email : '-'}
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <span>Status Perkawinan</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {profile.statusPerkawinan ? profile.statusPerkawinan : '-'}
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <span>Alamat Identitas</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {profile.alamatIdentitas ? profile.alamatIdentitas : '-'}
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <span>NPWP</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {profile.npwp ? profile.npwp : '-'}
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <span>Alamat Korespondensi</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {profile.alamatKorespondensi
                      ? profile.alamatKorespondensi
                      : '-'}
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <span>Status Pajak</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {profile.statusPajak ? profile.statusPajak : '-'}
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <span>Jenis Pembayaran Iuran</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {profile.jenisPembayaranIuran
                      ? profile.jenisPembayaranIuran
                      : '-'}
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <span>Rekening Bank</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {profile.rekeningBank ? profile.rekeningBank : '-'}
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <span>Rekening Auto Debet</span>
                </div>
                <div className="col-md-6 d-flex justify-content-end">
                  <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                    {profile.rekeningAutoDebet
                      ? profile.rekeningAutoDebet
                      : '-'}
                  </span>
                </div>
              </div>
            </section>
          </Card.Body>
        </Card>
      </div>
    )
  }
}

export default ProfilePeserta
